import { useState } from 'react';
import { GlobeIcon, Sparkles, GraduationCap, Map } from 'lucide-react';

export default function Introduction() {
  const [activeSection, setActiveSection] = useState(0);
  
  const sections = [
    {
      icon: <GlobeIcon className="w-16 h-16 text-orange-500" />,
      title: "Cultural Festivals",
      content: "Organize events featuring Andhra Pradesh's art forms...",
      image: "/images/culture.jpg", // Add your image path
      color: "bg-orange-100",
      border: "border-orange-500",
      imageAlt: "Cultural Festivals"
    },
    {
      icon: <Sparkles className="w-16 h-16 text-blue-500" />,
      title: "Cross-Cultural Workshops",
      content: "Arrange workshops on Dutch architecture...",
      image: "/images/workshops.jpg",
      color: "bg-blue-100",
      border: "border-blue-500",
      imageAlt: "Cross-Cultural Workshops"
    },
    {
      icon: <GraduationCap className="w-16 h-16 text-green-500" />,
      title: "Educational Exchange",
      content: "Promote student and faculty exchange programs...",
      image: "/images/education.jpg",
      color: "bg-green-100",
      border: "border-green-500",
      imageAlt: "Educational Exchange"
    },
    {
      icon: <Map className="w-16 h-16 text-purple-500" />,
      title: "Heritage Tourism",
      content: "Partner with tourism boards to promote heritage...",
      image: "/images/tourism.jpg",
      color: "bg-purple-100",
      border: "border-purple-500",
      imageAlt: "Heritage Tourism"
    }
  ];
  

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded-xl shadow-xl">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent mb-4">
          Netherlands-India Partnership
        </h2>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          How the Netherlands can strategically invest in Green Energy, Urban planning, Agri-Tech, Cultural Exchange – Heritage Tourism,India
        </p>
      </div>

      {/* Main Content */}
      <div className="mb-8">
        <h3 className="text-2xl font-bold text-center mb-8 pb-2 border-b-2 border-blue-500 inline-block">
          Conduct Cultural, Commerce, Knowledge Exchange Programs
        </h3>

        {/* Interactive Section */}
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Navigation Tabs */}
          <div className="lg:w-1/3">
            <div className="flex lg:flex-col gap-2">
              {sections.map((section, index) => (
                <button
                  key={index}
                  onClick={() => setActiveSection(index)}
                  className={`relative flex items-center text-left p-4 rounded-lg transition-all duration-300 hover:shadow-md ${
                    activeSection === index 
                      ? `${section.color} ${section.border} border-l-4 shadow-md` 
                      : 'bg-gray-50 hover:bg-gray-100'
                  } flex-grow lg:flex-grow-0`}
                >
                  <div className="flex flex-col gap-2">
                    <span className="font-semibold text-gray-800">{section.title}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Content Display */}
          <div className="lg:w-2/3">
            <div className={`rounded-xl p-6 transition-all duration-500 ${sections[activeSection].color} border ${sections[activeSection].border}`}>
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0 flex justify-center">
                  {sections[activeSection].icon}
                </div>
                <div className="flex-grow">
                  <h4 className="text-2xl font-bold mb-3">{sections[activeSection].title}</h4>
                  <p className="text-lg mb-4">{sections[activeSection].content}</p>
                  
                  {/* Image section - using placeholder API */}
                  <img 
  src={sections[activeSection].image} 
  alt={sections[activeSection].imageAlt} 
  className="w-full h-48 object-cover rounded-lg shadow-md"
/>

                </div>
              </div>

              {/* Navigation Dots */}
              <div className="flex justify-center mt-6 gap-2">
                {sections.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveSection(index)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      activeSection === index ? 'bg-blue-600 w-6' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Outcome Section */}
      <div className="bg-gradient-to-r from-blue-50 to-green-50 p-6 rounded-xl shadow mt-8">
        <h3 className="text-xl font-bold mb-2 text-gray-800">Outcome:</h3>
        <p className="text-lg">
          Improved mutual understanding, stronger cultural ties, and increased tourism between regions
        </p>
      </div>
    </div>
  );
}